import { isEmpty } from '../../../helpers/isEmpty';
import { makeStyles } from '@material-ui/core/styles';
import FileSelector from '../../../Containers/WrappedAtoms/FileSelector';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import React from 'react';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import _ from 'lodash';

import { IFieldTypeSelector, IFieldTypeText, IFieldTypeToggle } from '../../../Interfaces/discover.interfaces';

const useStyles = makeStyles((theme:any) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    dense: {
        marginTop: 19,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        width: '100%',
    },
    menu: {
        width: 200,
    },
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
}));

export const SimpleTextInput = ({
    helperText,
    hook,
    key,
    label,
    multiline = false,
    name,
    required,
}: IFieldTypeText) => {
    const classes = useStyles();

    return (
        <FormControl className={classes.formControl} error={!isEmpty(hook.errors[name])}>
            <TextField
                className={classes.textField}
                id={`text-field-${name}`}
                label={label}
                margin="normal"
                multiline={multiline}
                name={name}
                onChange={hook.handleChange}
                placeholder={`Enter your ${name} here`}
                required={required}
                rows={multiline ? 6 : 1}
                value={hook.values[name]}
            />
            <FormHelperText>{hook.errors[name]}</FormHelperText>
        </FormControl>
    );
};

export const FieldTypeSelector = ({ hook, label, name, options }: IFieldTypeSelector) => {
    const classes = useStyles();
    const inputLabel = React.useRef<HTMLLabelElement>(null);
    // const [labelWidth, setLabelWidth] = React.useState(0);
    // React.useEffect(() => {
    //     if (inputLabel.current) setLabelWidth(inputLabel.current.offsetWidth);
    // }
    //     , []);

    return (
        <FormControl className={classes.formControl} error={!isEmpty(hook.errors[name])} variant="outlined">
            <InputLabel htmlFor={`options-${name}`} ref={inputLabel}>
                {label}
            </InputLabel>
            <Select id={`options-${name}`} name={name} onChange={hook.handleChange} value={hook.values[name] || ''}>
                {options.map((type: any, index: number) => (
                    <MenuItem key={index} value={type.value}>
                        {type.label}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText>{hook.errors[name]}</FormHelperText>
        </FormControl>
    );
};

export const SimpleToggleField = ({ additionalFields, hook, label, name }: IFieldTypeToggle) => {
    return (
        <FormControlLabel
            control={
                <Switch
                    checked={hook.values[name] === true}
                    disabled={_.get(additionalFields, 'disabled', false)}
                    inputProps={{ 'aria-label': label }}
                    name={name}
                    onChange={hook.handleChange}
                    value={true}
                />
            }
            label={label}
            labelPlacement="top"
        />
    );
};

export const TypeScrollableTextFields = ({ hook }: any) => (
    <SimpleTextInput
        helperText="Please enter your text above"
        hook={hook}
        label="Text goes here..."
        multiline={true}
        name="scrollableText"
    />
);

export const SimpleImageField = ({ hook, name, ...additional }: any) => {
    return (
        <FormControl error={!isEmpty(hook.errors[name])}>
            <FileSelector
                buttonLabel="Select image"
                name={name}
                onFileSelection={(res: any) => {
                    //Loop through the response and store the values of all sizes
                    let payload: any = {};
                    Object.keys(res).map(size => {
                        payload[size] = res[size];
                        return true;
                    });

                    hook.handleChange({
                        target: {
                            name,
                            value: payload,
                        },
                    });
                }}
                required={additional.required}
                requiredType={additional.requiredType}
                sizes={additional.sizes}
            />
            {hook.values[name] && !additional.hideImageOnSelection && (
                <img
                    alt={`${name}`}
                    src={hook.values[name][additional.sizes.sort((a: number, b: number) => a + b)[0]]}
                    width="150"
                />
            )}
            <FormHelperText>{hook.errors[name]}</FormHelperText>
        </FormControl>
    );
};
